import React from "react";
import { useInView } from "../../hooks/g4/useInView";

export function FadeInSection({ children, className = "", delay = 0 }) {
    const [ref, inView] = useInView();
    return (
        <div
            ref={ref}
            className={className}
            style={{
                opacity: inView ? 1 : 0,
                transform: inView ? "translateY(0)" : "translateY(32px)",
                transition: `opacity 0.7s ease-out ${delay}s, transform 0.7s ease-out ${delay}s`,
            }}
        >
            {children}
        </div>
    );
}

export function FadeInGroup({ children, className = "", staggerDelay = 0.12 }) {
    const [ref, inView] = useInView();
    return (
        <div ref={ref} className={className}>
            {React.Children.map(children, (child, i) =>
                React.isValidElement(child) ? (
                    <div
                        style={{
                            opacity: inView ? 1 : 0,
                            transform: inView ? "translateY(0)" : "translateY(24px)",
                            transition: `opacity 0.6s ease-out ${i * staggerDelay}s, transform 0.6s ease-out ${i * staggerDelay}s`,
                        }}
                    >
                        {child}
                    </div>
                ) : (
                    child
                )
            )}
        </div>
    );
}
